import { useConfigTypeTitle } from '@eggplant/routing'

const NoAvailableTestCase = () => {
  const configTypeText = useConfigTypeTitle()

  return (
    <>
      If your new test case is not listed above, please
      refresh this page. Save your {configTypeText} config beforehand
      to avoid losing changes.
    </>
  )
}

export default NoAvailableTestCase
